module.exports = __webpack_public_path__ + "img/2icon-选中.41a30ad1.png";